import cx from 'classnames'
import type React from 'react'

import css from './styles.module.scss'

interface Props {
  checked: boolean
}

// The circle is 14px drawn inside a 16px box, and the tick is positioned in
// that same box rather than inside the circle — both come straight from the
// design's percentages.
export const DayCheck: React.FC<Props> = ({ checked }) => (
  <span className={cx(css.check, checked && css.checked)}>
    <span className={css.circle} />

    <svg aria-hidden className={css.tick} fill="none" viewBox="0 0 16 16">
      <path
        d="M4.8 8.3 7 10.3l4.2-4.3"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.6"
      />
    </svg>
  </span>
)
